import React from "react";
import { TextField, TextFieldProps } from "@mui/material";
import { InputStyles } from "./StyledIInput.styles";

const StyledInput = ({ sx = {}, ...props }: TextFieldProps) => {
  return (
    <TextField
      placeholder="https://"
      sx={{
        ...InputStyles,
        ...sx,
      }}
      {...props}
    />
  );
};

export default StyledInput;
